export default __webpack_public_path__ + "static/media/symbol.87d4650e.svg";